import ApiClient from '@/api/ApiClient';
import { ARMADO_URL } from '@/utils/CONST';

const client = new ApiClient('User');

class UserApi {

	static getUserInfos () {
		return client.get<IUserSelfInformationModel & { organizationUserId?: number }>('self');
	}

	static getUserFullInfos () {
		return client.get<IUserFullInformationForAppModel>('informations');
	}

	/* static getConnectionState (id: number) {
		return client.get(`${id}/connectionState`);
	} */

	static getActivity () {
		client.windowOpen(`${ARMADO_URL}/app/user/activity`, '_blank');
	}

	static activationDetails (token: string) {
		return client.get<IUserActivationInformationsModel>(`activationDetails?token=${token}`);
	}

	static activate (userActivationModel: IUserActivationModel) {
		return client.post<void>(`activate`, userActivationModel);
	}

	static sendMailResetPassword (email: string) {
		return client.get<void>(`resetPassword/${email}`);
	}

	static update (userModel: IUpdateUserAndPersonnalInformationModel) {
		/* if (userModel.birthDay) {
			userModel = cloneDeep(userModel);
			userModel.birthDay = userModel.birthDay?.toPost();
		} */
		return client.put<void>(``, userModel);
	}

	static add (addUserFromFrontModel: Omit<IAddUserFromFrontModel, 'userId'>) {
		return client.post<IOrganizationUserDetailModel>('', addUserFromFrontModel);
	}

	static sendEmailActivation (id: number) {
		return client.post<void>(`sendEmailActivation/${id}`);
	}

	static signup (signupModel: ISignupUserModel) {
		return client.post<IUserFullInformationModel>('signup', signupModel);
	}

	static getForOrganizationalChart (pagedListParameters: IUserFilterForOrganizationalChartPagedListParameters) {
		return client.get<IPagedList<IUserForOrganizationalChartModel>>('organizationalChart', { params: pagedListParameters });
	}

}

export default UserApi;
